import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const BagComment = styled.p`
  color: ${THEME.grey};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1.43;
  margin: 0;
`;

export const Country = styled.span`
  color: ${THEME.grey};
  margin-left: 10px;
`;

export const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.8;
`;

export const LuggageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Span = styled.span`
  color: ${THEME.grey};
  margin-right: 10px;
  user-select: none;
`;

export const Text = styled.div`
  color: ${THEME.bobBlack};
  display: flex;
  flex-direction: row;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
`;

export const Title = styled.p`
  color: ${THEME.grey};
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  margin: 0 25px 0 0;
  min-width: 80px;
`;

export const useContactLuggageStyles = makeStyles(theme => ({
  root: {
    borderBottom       : `1px solid ${THEME.lightGrey}`,
    display            : 'grid',
    padding            : theme.spacing(5),
    gridGap            : theme.spacing(4),
    gridTemplateColumns: '1fr',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '& > span': {
      width              : 'fit-content',
      display            : 'grid',
      gridTemplateColumns: '90px 1fr',
    },
  },
}));
